module.exports = __webpack_public_path__ + "static/media/chupchups.c041767b.jpg";